import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import { useSiteFeatureFlags } from '../../hooks/useSiteFeatureFlags';

// One slim row instead of the CRM's full footer: brand, the legal/contact links
// the site really has, and the footer line from Dev -> File Transfer.
const LEGAL = [
  { to: '/terms-conditions', label: 'Terms' },
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/accessibility', label: 'Accessibility' },
];

const TransferSiteFooter = ({ dark = false, text = '' }) => {
  const { siteName } = useSiteSettings();
  const { transfer_site_enabled } = useSiteFeatureFlags();
  // The CRM contact page is not part of the Transfer Site template; its Support page is.
  const LINKS = [{ to: transfer_site_enabled ? '/p/support' : '/contact', label: transfer_site_enabled ? 'Support' : 'Contact' }, ...LEGAL];
  const ink = dark ? 'text-white/70' : 'text-slate-500';
  const hover = dark ? 'hover:text-white' : 'hover:text-slate-900';

  return (
    <footer className={`${dark ? 'bg-slate-950 border-white/10' : 'bg-white border-slate-200'} border-t`} data-testid="transfer-footer">
      <div className={`max-w-7xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 text-xs ${ink}`}>
        <p>
          &copy; {new Date().getFullYear()}{siteName ? ` ${siteName}` : ''}
          {text ? <span className="ml-2">{text}</span> : null}
        </p>
        <nav aria-label="Footer" className="flex flex-wrap items-center">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`min-h-[44px] px-3 inline-flex items-center ${hover}`}>{l.label}</Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default TransferSiteFooter;
